import { readAuthIntent } from '@/helpers/authIntent'

const origin = window.location.origin

const findUrl = () => {
  const currentUrl = window.location.hostname
  const portUrl = window.location.port
  if (portUrl) {
    return 'http://' + currentUrl + ':' + portUrl
  } else {
    return 'https://' + currentUrl
  }
}

/** Callback URL including auth intent so signup survives Auth0 redirects / magic links. */
export function buildAuth0CallbackUrl(
  callbackLandingPage: string | null | undefined = null
): string {
  const params = new URLSearchParams()
  params.set('authintent', readAuthIntent())
  if (callbackLandingPage) {
    params.set('callbacklandingpage', String(callbackLandingPage))
  }
  return `${origin}/callback?${params.toString()}`
}

const logoutUrl = () => {
  return `${origin}/`
}

export const HELPERS = {
  currentUrl: findUrl(),
  // Static fallback for Auth0 client init; passwordless calls use buildAuth0CallbackUrl().
  callbackUrl: `${origin}/callback`,
  logoutUrl: logoutUrl(),
}
